import { render } from "./About.vue?vue&type=template&id=59eac22b&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=59eac22b&scoped=true&lang=css"

import exportComponent from "/home/zoa/Documents/vue_dev/rachaelmason/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59eac22b"]])

export default __exports__